<mat-card appearance="outlined" class="mat-card-recording_info_mwst">
  <div style="display: flex; flex-direction: column; height: 100%;">
    <mat-card-header>
      <p class="card_measured_data_title" i18n="@@home.mwstftgRecording.title.measurementResult">
        <span class="material-icons-outlined">pie_chart</span>
        {{ this.recordData?.data.recordTypeView }} 測定結果
      </p>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content class="protocol-detail">
      <div class="content content-padding-top content-padding-bottom">
        <div class="left-panel">
          <div class="header">
            <h1></h1>
          </div>
          <div class="grade-circle">
            <span>{{ this.recordData?.data.finalScore }}</span>
          </div>
          <div class="grade-text" i18n="@@home.mwstftgRecording.label.grade">評点</div>
        </div>

        <div class="right-panel display-block">
          <div class="header">
            <h2 i18n="@@home.mwstftgRecording.title.evaluationCriteria">{{ this.recordData?.data.recordTypeView }}評価基準</h2>
            <p class="score-subtitle" i18n="@@home.mwstftgRecording.label.checkEachGrade">各評点を確認してください</p>
          </div>
          <div class="mwstftg-list">
            <mat-list class="score-list" role="list">
              @for (result of results; track result) {
                <mat-list-item
                  [ngClass]="{
                    'selected-item': result.value === this.recordData?.data.finalScore,
                    'unselected-item': result.value !== this.recordData?.data.finalScore
                  }"
                  role="listitem"
                  [attr.aria-selected]="result.value === this.recordData?.data.finalScore"
                >
                  <mat-icon matListItemIcon class="score-icon">
                    {{ result.value === this.recordData?.data.finalScore ? 'check_box' : 'check_box_outline_blank' }}
                  </mat-icon>
                  <div class="score-body">
                    <div class="score-label" i18n="@@home.mwstftgRecording.label.gradeValue">評点{{ result.value }}</div>
                    <div
                      class="score-desc"
                      [ngClass]="{
                        'long-desc': (result.description?.length || 0) > 40,
                        'xlong-desc': (result.description?.length || 0) > 70
                      }"
                      [attr.title]="result.description"
                    >
                      {{ result.description }}
                    </div>
                  </div>
                </mat-list-item>
              }
            </mat-list>
          </div>
        </div>
      </div>
    </mat-card-content>
  </div>
</mat-card>
